import { ComponentEntity } from "src/app/core/entities/component.entity";

export abstract class ServiceBookItemFormModel {
   Name: string;
   Description: string;
   SiteId: string;
   LineIds: string[];
   ProductIds: string[];
   BasicInformation: ComponentEntity;
}